import {
  FC,
  createContext,
  useContext,
  ReactNode,
  useState,
  ChangeEvent,
} from 'react';

interface WbTabsContextValue {
  value: number;
  onChange: (event: ChangeEvent<{}>, newValue: number) => void;
  setValue: (value: number) => void;
}

const WbTabsContext = createContext<WbTabsContextValue | undefined>(undefined);

interface WbTabsProviderProps {
  children: ReactNode;
  defaultValue?: any;
}

export const WbTabsProvider: FC<WbTabsProviderProps> = ({
  children,
  defaultValue = 0,
}) => {
  const [value, setValue] = useState(defaultValue);

  const onChange = (_event: ChangeEvent<{}>, newValue: any) => {
    setValue(newValue);
  };

  return (
    <WbTabsContext.Provider value={{ value, onChange, setValue }}>
      {children}
    </WbTabsContext.Provider>
  );
};

export const useWbTabsContext = () => {
  const context = useContext(WbTabsContext);
  if (!context) {
    throw new Error('useWbTabsContext must be used within a WbTabsProvider');
  }
  return context;
};
